import { useEffect, useState } from "react";
import { usePersistentState } from "./contexts/global-context";
import { GetLocalStorage } from "./utils/local-storage";
import { HostRouter } from "./host-router";
import { AdminRouter } from "./admin-router";
import LoginRoutes from "./login-routes";

export const DashboardRouter = () => {
  const [state]: any = usePersistentState();
  const [loginInfo, setLoginInfo] = useState<any>(false);

  useEffect(() => {
    let tempData = GetLocalStorage("loginData");
    setLoginInfo(tempData);
  }, [state.users]);

  const LoginData = () => {
    let tempData = GetLocalStorage("loginData");
    if (tempData) {
      return true;
    } else {
      return false;
    }
  };
  if (LoginData()) {
    const isHost =
      loginInfo?.roles?.name?.toLowerCase() === "host" &&
      loginInfo?.roles?.id !== 1;
    if (isHost) {
      return <HostRouter />;
    } else {
      return <AdminRouter />;
    }
  } else {
    return <LoginRoutes />;
  }
};
